export const shouldLoad = () => document.querySelector('.klt-overlay-menu') !== undefined;